// scroll bar
import 'simplebar/src/simplebar.css';
import './App.css';

import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';


import App from './App';
import * as serviceWorker from './serviceWorker';
import { CentroProvider } from './contextos/CentroContext';

// Interceptor global para que TODAS las peticiones fetch envíen automáticamente el centro activo al backend
if (typeof window !== 'undefined' && window.fetch) {
  const originalFetch = window.fetch;
  window.fetch = function customFetch(resource, init = {}) {
    const params = new URLSearchParams(window.location.search);
    const queryCentro = params.get('centro') || params.get('centroId');
    const savedCentro = sessionStorage.getItem('preferred_centro_id');
    const hostCentro = window.location.hostname.toLowerCase().includes('lagasca') ? 'lagasca' : 'rosales';
    const activeCentroId = queryCentro || savedCentro || hostCentro;

    const headers = new Headers(init.headers || {});
    if (!headers.has('x-centro-id')) {
      headers.set('x-centro-id', activeCentroId);
    }
    return originalFetch(resource, { ...init, headers });
  };
}

// ----------------------------------------------------------------------

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <HelmetProvider>
    <BrowserRouter>
      <CentroProvider>
        <App />
      </CentroProvider>
    </BrowserRouter>
  </HelmetProvider>
);

// If you want to enable client cache, register instead.
serviceWorker.unregister();

